
import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Table, TableBody, TableCaption, TableHead, 
  TableHeader, TableRow 
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useUserManagement } from "@/hooks/useUserManagement";
import UsersTable from './users/UsersTable';
import UserPointsForm from './users/UserPointsForm';
import UserSearchBar from './users/UserSearchBar';
import ExportCSVButton from './users/ExportCSVButton';

const UserManagement: React.FC = () => {
  const { t } = useTranslation(['admin', 'common']);
  const {
    users,
    loading,
    searchQuery,
    setSearchQuery,
    selectedUser,
    setSelectedUser,
    pointsToAdd,
    setPointsToAdd,
    handleAddPoints,
    handleUpdateTier
  } = useUserManagement();

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>{t('admin:userManagement')}</CardTitle>
          <ExportCSVButton filteredUsers={users} />
        </CardHeader>
        <CardContent>
          <UserSearchBar 
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
          />

          <div className="border rounded-md overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t('admin:user')}</TableHead>
                  <TableHead>{t('admin:email')}</TableHead>
                  <TableHead>{t('admin:points')}</TableHead>
                  <TableHead>{t('admin:tier')}</TableHead>
                  <TableHead>{t('admin:joined')}</TableHead>
                  <TableHead>{t('admin:actions')}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <UsersTable
                  users={users}
                  loading={loading}
                  onSelectUser={setSelectedUser}
                  onUpdateTier={handleUpdateTier}
                />
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      {selectedUser && (
        <UserPointsForm
          selectedUser={selectedUser}
          pointsToAdd={pointsToAdd}
          onPointsChange={setPointsToAdd}
          onAddPoints={handleAddPoints}
        />
      )}
    </div>
  );
};

export default UserManagement;
